module.exports = __webpack_public_path__ + "icon3.png?b7c4a36cbe57b99c055716462d47c210";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon3.png
// module id = 360
// module chunks = 0